module.exports = __webpack_public_path__ + "static/cosmos-9eeac505f16cf8e63f8b031985d7aa64.png";